<template>
  <div class="admin desktop">
    <h1 style="font-size: 19pt; font-weight: 600" class="mb-4">My account</h1>

    <div class="mb-4">
      <v-card
        style="
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
          min-width: 600px;
          width: 700px;
        "
        class="pa-6"
      >
        <div>
          <h2 class="mb-4" style="font-size: 16pt; font-weight: 600">
            Profile
          </h2>
          <div>
            <div
              class="mb-4"
              style="display: grid; grid-template-columns: 1fr 1fr; gap: 5px"
            >
              <div>
                <p style="font-size: 12px; margin-bottom: 5px">First name</p>
                <v-text-field
                  variant="solo"
                  flat
                  bg-color="smoke"
                  style="border-radius: 6px"
                  hide-details=""
                  v-model="userProfile.first_name"
                  @change="updateName()"
                ></v-text-field>
              </div>
              <div>
                <p style="font-size: 12px; margin-bottom: 5px">Last name</p>
                <v-text-field
                  variant="solo"
                  flat
                  bg-color="smoke"
                  style="border-radius: 6px"
                  hide-details=""
                  v-model="userProfile.last_name"
                  @change="updateName()"
                ></v-text-field>
              </div>
            </div>

            <div
              style="display: grid; grid-template-columns: 1fr 1fr; gap: 5px"
            >
              <div>
                <p style="font-size: 12px; margin-bottom: 5px">Email</p>
                <v-text-field
                  variant="solo"
                  flat
                  bg-color="smoke"
                  style="border-radius: 6px"
                  class="mb-4"
                  hide-details=""
                  readonly
                  v-model="userProfile.email"
                ></v-text-field>
              </div>

              <div>
                <p style="font-size: 12px; margin-bottom: 5px">Joined</p>
                <v-text-field
                  variant="solo"
                  flat
                  bg-color="smoke"
                  style="border-radius: 6px"
                  class="mb-2"
                  hide-details=""
                  :model-value="getTime(userProfile.created_at)"
                  readonly
                ></v-text-field>
              </div>
            </div>
          </div>
          <v-btn
            elevation="0"
            variant="text"
            class="primary--text mt-4"
            size="small"
            >Delete account</v-btn
          >
        </div>
      </v-card>
    </div>

    <div>
      <v-card
        flat
        v-if="userProfile"
        style="
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
          min-width: 600px;
          width: 700px;
        "
      >
        <div class="pa-6">
          <h2 class="mb-4" style="font-size: 16pt; font-weight: 600">Emails</h2>
          <div>
            <p style="font-size: 12px; margin-bottom: 5px">Emails</p>
            <div class="d-flex justify-space-between" style="gap: 5px">
              <div>
                <p class="mb-0">Newsletter</p>
                <p style="font-size: 12px">New blog posts and more</p>
              </div>
              <div>
                <v-switch
                  color="accent"
                  class="mt-0 pt-0"
                  v-model="newsletter"
                ></v-switch>
              </div>
            </div>

            <div class="d-flex justify-space-between" style="gap: 5px">
              <div>
                <p class="mb-0">Weekly summary</p>
                <p style="font-size: 12px">
                  Summary of your social performances
                </p>
              </div>
              <v-switch
                color="accent"
                class="mt-0 pt-0"
                v-model="summary"
              ></v-switch>
            </div>

            <div class="d-flex justify-space-between" style="gap: 5px">
              <div>
                <p class="mb-0">Idea daily</p>
                <p style="font-size: 12px">Every day a new post idea</p>
              </div>
              <v-switch
                color="accent"
                class="mt-0 pt-0"
                v-model="ideas"
              ></v-switch>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { DateTime } from "luxon";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
    }),
  },
  watch: {
    newsletter(newValue) {
      this.$store.dispatch("updateNotifications", {
        type: "newsletter",
        val: newValue,
      });
    },
    summary(value) {
      this.$store.dispatch("updateNotifications", {
        type: "summary",
        val: value,
      });
    },
    ideas(value) {
      this.$store.dispatch("updateNotifications", {
        type: "ideas",
        val: value,
      });
    },
  },
  data() {
    return {
      edit: false,
      ideas: this.userProfile
        ? this.userProfile.preferences.notifications.ideas
        : false,
      summary: this.userProfile
        ? this.userProfile.preferences.notifications.summary
        : false,
      newsletter: this.userProfile
        ? this.userProfile.preferences.notifications.newsletter
        : false,
    };
  },
  methods: {
    getTime(t) {
      console.log(t);
      let time = DateTime.fromSeconds(t);
      return time.toFormat("dd-MM-yyyy");
    },
    updateTitle() {
      this.$store.dispatch("updateTitle", this.userProfile.job_title);
    },
    updateName() {
      this.$store.dispatch("updateName", {
        first_name: this.userProfile.first_name,
        last_name: this.userProfile.last_name,
      });
    },
  },
};
</script>
